/* MXDVS collection page, 30.09.2026 (v2: calm arrival)
   Section: sections/mxdvs-collection-page.liquid. Styles: assets/mxdvs-collection-page.css.
   Uses the shared product card (snippets/mxdvs-card.liquid, assets/mxdvs-card.js) and the homepage
   grid styles (assets/mxdvs-home.css), so the grid matches the homepage feature layout.

   - Calm arrival: every product plays one short move the first time it comes into view, then stays
     still. Cards that arrive together follow each other with a small delay along the row.
     Develop (default): the photo sharpens from blurred and grey into colour like a print, then the
     name and price appear. Settle and Drift are the two other options in the theme editor.
   - Scroll effects: focus pull, decode on arrival, image parallax, second image on scroll (phones)
     and a terminal counter at the bottom.
   - Typed collection description (the block cursor goes once it is complete); the terminal path links decode on hover.
   - View more: loads the next page without a reload, then switches on infinite scroll.
   - Filters and sort (30.09): one chip row (in stock, limited, sale with a broken tube light flicker,
     type, size, price) and a terminal sort, across the whole collection.
   09.10.2026: the typed description keeps its final height from the start; sort starts on newest; Limited = the
   "limited" tag; decoding names only use narrow letters.
   Respects reduced motion. */
(function () {
  if (window.MxCollectionPage) return;

  /* 09.10.2026: only letters and digits no wider than the real ones (no W, M, Q or symbols), so a decoding name never breaks onto a second line */
  var GLYPHS = 'ABCDEFGHIJKLNOPRSTUVXYZ0123456789';
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  function reduce() { return reduceMq.matches; }

  function decode(el, text, ms, done) {
    if (el._mxcDec) cancelAnimationFrame(el._mxcDec);
    if (reduce() || ms <= 1) { el.textContent = text; if (done) done(); return; }
    var t0 = performance.now();
    (function step(now) {
      var k = Math.min(1, (now - t0) / ms), out = '';
      for (var i = 0; i < text.length; i++) {
        var ch = text[i];
        out += (ch === ' ' || i / text.length < k) ? ch : GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
      }
      el.textContent = out;
      if (k < 1) el._mxcDec = requestAnimationFrame(step); else if (done) done();
    })(t0);
  }
  function scramble(t) {
    return t.replace(/[^\s.,|€$£]/g, function () { return GLYPHS[Math.floor(Math.random() * GLYPHS.length)]; });
  }

  /* ============================================================
     CALM ARRIVAL: plays once per card as it comes into view
     ============================================================ */
  function mxArrive(root, conf, onChange) {
    var list = root.querySelector('.mx-col__list');
    var a = conf.arrive || {};
    var fx = conf.fx || {};
    var io = null;

    function place() {
      var g = list.getBoundingClientRect();
      Array.prototype.forEach.call(list.children, function (li) {
        var x = 0, y = a.dist || 0;
        if (a.style === 'drift') {
          var r = li.getBoundingClientRect();
          var side = (r.left + r.width / 2 - g.left) / (g.width || 1) < 0.5 ? -1 : 1;
          if (r.width > g.width * 0.9) side = -1;
          x = side * (a.dist || 0);
          y = 0;
        }
        li.style.setProperty('--mxa-x0', x + 'px');
        li.style.setProperty('--mxa-y0', y + 'px');
      });
    }

    function prep(li) {
      var card = li.querySelector('.mx-card');
      if (!card) return;
      card._placed = false;
      if (!fx.decode || reduce()) return;
      var n = card.querySelector('[data-decode]'), pr = card.querySelector('.mx-card__price');
      if (n) n.textContent = scramble(n.getAttribute('data-decode'));
      if (pr) {
        if (!pr._mxcHtml) { pr._mxcHtml = pr.innerHTML; pr._mxcPlain = pr.textContent.replace(/\s+/g, ' ').trim(); }
        pr.textContent = scramble(pr._mxcPlain);
      }
      card._scrambled = true;
    }

    function arrive(li, i) {
      var delay = i * (a.stagger || 0);
      li.style.setProperty('--mxa-delay', delay + 'ms');
      li.classList.add('is-in');
      var card = li.querySelector('.mx-card');
      if (card) {
        card._placed = true;
        if (card._scrambled) {
          card._scrambled = false;
          setTimeout(function () {
            var n = card.querySelector('[data-decode]'), pr = card.querySelector('.mx-card__price');
            if (n) decode(n, n.getAttribute('data-decode'), fx.decodeMs || 500);
            if (pr && pr._mxcHtml) decode(pr, pr._mxcPlain, fx.decodeMs || 500, function () { pr.innerHTML = pr._mxcHtml; });
          }, delay + (a.dur || 1000) * 0.35);
        }
      }
      onChange();
    }

    function leave(li) {
      li.style.setProperty('--mxa-delay', '0ms');
      li.classList.remove('is-in');
      prep(li);
      onChange();
    }

    function watch() {
      place();
      Array.prototype.forEach.call(list.children, function (li) {
        if (li._mxaWatched) return;
        li._mxaWatched = true;
        if (reduce() || !io) { li.classList.add('is-in'); var c = li.querySelector('.mx-card'); if (c) c._placed = true; return; }
        prep(li);
        io.observe(li);
      });
      onChange();
    }

    if (!reduce() && 'IntersectionObserver' in window) {
      root.classList.add('mxa', 'mxa--' + (a.style || 'develop'));
      io = new IntersectionObserver(function (entries) {
        entries.filter(function (e) { return e.isIntersecting && !e.target.classList.contains('is-in'); })
          .sort(function (x, y) { return (x.boundingClientRect.top - y.boundingClientRect.top) || (x.boundingClientRect.left - y.boundingClientRect.left); })
          .forEach(function (e, i) {
            arrive(e.target, i);
            if (!a.replay) io.unobserve(e.target);
          });
        if (a.replay) {
          entries.forEach(function (e) {
            if (!e.isIntersecting && e.boundingClientRect.top > 0 && e.target.classList.contains('is-in')) leave(e.target);
          });
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }

    window.addEventListener('resize', place);
    new MutationObserver(watch).observe(list, { childList: true });
    watch();
    return { watch: watch };
  }

  /* ============================================================
     SCROLL EFFECTS: focus pull, image parallax, second image on scroll
     (phones) and the terminal counter
     ============================================================ */
  function mxFx(root, fx, isMobile, counterEl) {
    var list = root.querySelector('.mx-col__list');
    var queued = false;
    function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

    var skipped = false;
    function frame() {
      queued = false;
      var vh = window.innerHeight, mid = vh / 2;
      var mobile = isMobile();
      var still = reduce();

      /* 09.10.2026 (speed): phones with no parallax, no focus pull and no image swap skip the per-card work
         completely, so scrolling reads and writes nothing for the cards. Styles left from a wider window are
         cleared once. */
      var parM = fx.parPxM != null ? fx.parPxM : fx.parPx;
      var skip = mobile && !(fx.parallax && parM) && !(fx.focus && (fx.focusBlurM || fx.focusGreyM)) && !fx.swap;
      if (skip && !skipped) {
        list.querySelectorAll('.mx-card__img').forEach(function (img) { img.style.transform = ''; });
        list.querySelectorAll('.mx-card__media').forEach(function (m) { m.style.filter = ''; });
        list.querySelectorAll('.mx-card__veil').forEach(function (v) { v.style.opacity = ''; v._op = ''; });
      }
      skipped = skip;

      if (!skip) Array.prototype.forEach.call(list.children, function (li) {
        var media = li.querySelector('.mx-card__media');
        if (!media) return;
        var r = li.getBoundingClientRect();
        if (r.top > vh * 1.4 || r.bottom < -vh * 0.4) return;
        var c = r.top + r.height / 2;
        var d = (c - mid) / mid;

        /* Image parallax inside the frame. With the grey blend on, no zoom: the whole photo stays visible
           and the small shift never shows an edge. Without the blend, a slight zoom covers the edges. */
        var par = fx.parallax && !still ? (mobile ? parM : fx.parPx) : 0;
        var zoom = root.classList.contains('is-blend') ? 0 : 2.2 * par / (media.clientHeight || 1);
        var tf = par ? 'translate3d(0,' + (-d * par).toFixed(1) + 'px,0)' + (zoom ? ' scale(' + (1 + zoom).toFixed(4) + ')' : '') : '';
        media.querySelectorAll('.mx-card__img').forEach(function (img) { if (img.style.transform !== tf) img.style.transform = tf; });

        /* Second image while the card passes the middle of the screen (phones) */
        var alt = media.querySelector('.mx-card__img--alt');
        if (alt) {
          var main = media.querySelector('.mx-card__img:not(.mx-card__img--alt)');
          if (fx.swap && mobile) {
            var on = Math.abs(c - mid) < vh * fx.swapBand / 200;
            alt.style.opacity = on ? '1' : '0';
            /* The main photo steps aside, so the two photos never show through each other */
            if (main) main.style.opacity = on ? '0' : '';
          } else {
            alt.style.opacity = '';
            if (main) main.style.opacity = '';
          }
        }

        /* Focus pull: sharp in the middle band, soft and grey above and below.
           Phones have their own values: with two tall cards per row a card's middle rarely reaches the
           outer edge of the screen, so the desktop band would leave the blur almost invisible there. */
        var fBand = mobile && fx.focusBandM != null ? fx.focusBandM : fx.focusBand;
        var fBlur = mobile && fx.focusBlurM != null ? fx.focusBlurM : fx.focusBlur;
        var fGrey = mobile && fx.focusGreyM != null ? fx.focusGreyM : fx.focusGrey;
        /* 09.10.2026 (speed): desktop "Soft grey fade": a layer in the photo background colour fades in instead of
           blurring and greying the photo on every scroll frame (fx.focusStyle 'fade', strength fx.fadeStrength %).
           Phones: Blur (mobile) and Grey (mobile) 0 leave the photo untouched. */
        var fade = !mobile && fx.focusStyle === 'fade';
        var veil = media.querySelector('.mx-card__veil');
        if (fade && !veil) {
          veil = document.createElement('span');
          veil.className = 'mx-card__veil';
          veil.setAttribute('aria-hidden', 'true');
          media.insertBefore(veil, media.querySelector('.mx-tag')); /* above the photo, under the Sale / Sold out tags */
        }
        var a = fx.focus && !still ? clamp((Math.abs(d) - fBand / 100) / Math.max(0.01, 1 - fBand / 100)) : 0;
        var op = fade && a ? (a * (fx.fadeStrength != null ? fx.fadeStrength : 45) / 100).toFixed(2) : '';
        if (veil && veil._op !== op) { veil._op = op; veil.style.opacity = op; }
        var flt = !fade && a && (fBlur || fGrey) ? 'blur(' + (a * fBlur).toFixed(2) + 'px) grayscale(' + Math.round(a * fGrey) + '%)' : '';
        if (media.style.filter !== flt) media.style.filter = flt;
      });

      /* Terminal counter */
      if (counterEl) {
        if (!fx.counter) { counterEl.hidden = true; return; }
        var cards = list.querySelectorAll('.mx-card');
        var placed = 0;
        cards.forEach(function (card) { if (card._placed) placed++; });
        var total = parseInt(list.getAttribute('data-total'), 10) || cards.length;
        var allLoaded = !root.querySelector('[data-mxc-more]:not([hidden])');
        var pad = function (n) { return String(n).padStart(3, '0'); };
        var done = allLoaded && placed >= cards.length;
        var unit = counterEl.getAttribute('data-label') || 'units';
        var txt = done ? 'all ' + unit + ' in line' : 'loading ' + pad(Math.min(placed, total)) + '/' + pad(total) + ' ' + unit;
        if (counterEl.textContent !== txt) counterEl.textContent = txt;
        counterEl.hidden = false;
        counterEl.classList.toggle('is-done', done);
      }
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(frame); } }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    new MutationObserver(queue).observe(list, { childList: true });
    queue();
    return { update: queue };
  }

  /* ============================================================
     FILTERS AND SORT: chip row (in stock, limited, sale, type, size, price)
     and the terminal sort, run on the whole collection. The product list comes
     from templates/collection.mxdvs-data.liquid (?view=mxdvs-data, 250 a page).
     Until a chip or the sort is used, the page shows the normal server-rendered
     products; after that the grid is filled here, 24 at a time, with the same card.
     ============================================================ */
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function mxFilters(root, conf) {
    var fc = conf.filters || {};
    var box = root.querySelector('[data-mxc-filters]');
    if (!fc.enabled || !box) return null;
    var list = root.querySelector('.mx-col__list');
    var chipsEl = box.querySelector('[data-mxc-chips]');
    var countEl = box.querySelector('[data-mxc-count]');
    var sortEl = box.querySelector('[data-mxc-sort]');
    var hide = conf.hide || {};
    var str = conf.str || {};
    var sel = { avail: [], sale: [], type: [], size: [], price: [] };
    /* 09.10.2026: newest first by default (the date the product was added to the store); the collections
       themselves are set to "Newest" in the Shopify admin, so the page already loads in this order */
    var sort = 'newest';
    var all = null, loading = null, visible = [], shown = 0;
    var api = { client: false };

    /* Clothing sizes only (XS to 3XL and OSFA); ring, bracelet and chain sizes never become chips */
    var SIZE_MAP = { 'xs': 'XS', 'xsmall': 'XS', 'x-small': 'XS', 's': 'S', 'small': 'S', 'm': 'M', 'medium': 'M', 'l': 'L', 'large': 'L', 'xl': 'XL', 'xlarge': 'XL', 'x-large': 'XL', '2xl': '2XL', 'xxl': '2XL', 'xxlarge': '2XL', '2xlarge': '2XL', 'xx-large': '2XL', '3xl': '3XL', 'xxxl': '3XL', '3xlarge': '3XL', 'xxxlarge': '3XL', 'osfa': 'OSFA', 'one size fits all': 'OSFA', 'one size': 'OSFA', 'onesize': 'OSFA', 'os': 'OSFA' };
    var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'OSFA'];
    function sizeKey(v) { var k = String(v).toLowerCase().replace(/\s+/g, ' ').trim(); return SIZE_MAP[k] || ''; }
    function sizeLabel(k) { return k === 'OSFA' ? (str.oneSize || 'OSFA') : k; }
    /* Sizes only count for the clothing type chips set in the theme editor (tops and bottoms) */
    var SIZE_GROUPS = String(fc.sizeGroups || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    function sizesFor(p) {
      if (SIZE_GROUPS.length && SIZE_GROUPS.indexOf(String(p.group).toLowerCase()) < 0) return [];
      return String(p.sz || '').split('|').filter(Boolean).map(sizeKey).filter(Boolean);
    }

    /* Type groups from the theme editor, one per line: "Hoodies: Hoodie, Sweatshirt" */
    var TYPES = String(fc.types || '').split(/\n/).map(function (line) {
      var parts = line.split(':');
      if (parts.length < 2 || !parts[0].trim()) return null;
      return { label: parts[0].trim(), match: parts.slice(1).join(':').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean) };
    }).filter(Boolean);
    function typeOf(t) {
      t = String(t || '').toLowerCase().trim();
      for (var i = 0; i < TYPES.length; i++) if (TYPES[i].match.indexOf(t) > -1) return TYPES[i].label;
      return '';
    }
    var BANDS = fc.bands || [];
    function bandOf(p) {
      for (var i = 0; i < BANDS.length; i++) if (p.p < BANDS[i].max) return String(i);
      return String(BANDS.length);
    }

    function hidden(p) {
      if (p.h === 'free-gift') return true;
      if ((hide.handles || []).indexOf(p.h) > -1) return true;
      if (hide.soldOut && !p.av) return true;
      var v = String(p.vd || '').toLowerCase().trim();
      if ((hide.vendors || []).indexOf(v) > -1) return true;
      var tags = String(p.tg || '').split('|');
      return (hide.tags || []).some(function (t) { return t && tags.indexOf(t) > -1; });
    }

    /* Product lists: pages of 250, fetched side by side, kept for 5 minutes in this browser tab
       so going back to a collection shows the chips straight away */
    var CACHE_MS = 5 * 60 * 1000;
    function fetchAll(base) {
      var key = 'mxc:' + base;
      try {
        var hit = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (hit && Date.now() - hit.t < CACHE_MS) return Promise.resolve(hit.p);
      } catch (e) {}
      function page(n) {
        return fetch(base + (base.indexOf('?') > -1 ? '&' : '?') + 'page=' + n, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (t) { return JSON.parse(t); });
      }
      return page(1).then(function (first) {
        var more = [];
        for (var n = 2; n <= Math.min(first.pages || 1, 40); n++) more.push(page(n));
        return Promise.all(more).then(function (rest) {
          var out = (first.products || []);
          rest.forEach(function (d) { out = out.concat(d.products || []); });
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: out })); } catch (e) {}
          return out;
        });
      });
    }

    /* Facets first (no photos, very light), so the chips and counts show quickly */
    function load() {
      if (loading) return loading;
      loading = fetchAll(fc.facetsUrl || fc.dataUrl).then(function (out) {
        all = out.filter(function (p) { return !hidden(p); }).map(function (p) {
          p.lowtags = String(p.tg || '').split('|');
          /* 07.10.2026: Limited means the product has the "limited" tag (not low stock) */
          p.status = !p.av ? 'out' : (p.lowtags.indexOf('limited') > -1 ? 'lim' : 'in');
          p.group = typeOf(p.ty);
          p.sizes = sizesFor(p);
          p.band = bandOf(p);
          return p;
        });
        renderChips();
        setCount();
        /* Then the card data (photos, names, prices) in the background, ready before the first tap */
        cards();
      }).catch(function () {
        box.classList.add('is-failed');
      });
      return loading;
    }
    var cardsLoading = null;
    function cards() {
      if (cardsLoading) return cardsLoading;
      if (!fc.facetsUrl) { cardsLoading = Promise.resolve(); return cardsLoading; }
      cardsLoading = fetchAll(fc.dataUrl).then(function (out) {
        var byHandle = {};
        out.forEach(function (d) { byHandle[d.h] = d; });
        all.forEach(function (p) {
          var d = byHandle[p.h];
          if (!d) return;
          ['u', 't', 'pv', 'pm', 'cm', 'im', 'iw', 'ih', 'ia', 'am', 'aw', 'ah', 'aa'].forEach(function (k) { if (d[k] !== undefined) p[k] = d[k]; });
        });
      }).catch(function () {});
      return cardsLoading;
    }

    function match(p, g, v) {
      if (g === 'avail') return v === 'in' ? p.av : (p.av && p.status === 'lim');
      if (g === 'sale') return p.pct > 0;
      if (g === 'type') return p.group === v;
      if (g === 'size') return p.sizes.indexOf(v) > -1;
      if (g === 'price') return p.band === v;
    }
    function passes(p, skip) {
      return Object.keys(sel).every(function (g) {
        if (g === skip || !sel[g].length) return true;
        return sel[g].some(function (v) { return match(p, g, v); });
      });
    }
    function count(g, v) { return all.filter(function (p) { return passes(p, g) && match(p, g, v); }).length; }
    function results() {
      var r = all.filter(function (p) { return passes(p); });
      r.sort(function (a, b) {
        if (fc.soldLast) { var d = (a.av ? 0 : 1) - (b.av ? 0 : 1); if (d) return d; }
        if (sort === 'newest') return b.d - a.d || a.i - b.i;
        if (sort === 'low') return a.p - b.p || a.i - b.i;
        if (sort === 'high') return b.p - a.p || a.i - b.i;
        return a.i - b.i;
      });
      /* Never a sold out product in the big first card */
      if (r.length && !r[0].av) {
        var k = -1;
        for (var q = 0; q < r.length; q++) { if (r[q].av) { k = q; break; } }
        if (k > 0) r.unshift(r.splice(k, 1)[0]);
      }
      return r;
    }

    /* ---------- Chips ---------- */
    function chip(g, v, label, dot) {
      var on = sel[g].indexOf(v) > -1;
      var n = count(g, v);
      if (!on && n === 0 && fc.hideEmpty) return '';
      var text = g === 'sale' ? '<span class="f-neon">' + esc(label).split('').map(function (c) { return '<i>' + c + '</i>'; }).join('') + '</span>' : esc(label);
      var tip = g === 'size' && v === 'OSFA' ? (str.oneSizeHover || 'One size fits all') : '';
      return '<button type="button" class="fb__chip' + (!on && n === 0 ? ' is-empty' : '') + '" data-g="' + g + '" data-v="' + esc(v) + '" aria-pressed="' + on + '"' + (tip ? ' title="' + esc(tip) + '" aria-label="' + esc(tip) + '"' : '') + '>' +
        (dot ? '<span class="f-dot f-dot--' + dot + '" aria-hidden="true"></span>' : '') + '<span' + (tip ? ' data-hover="' + esc(tip) + '" data-rest="' + esc(label) + '"' : '') + '>' + text + '</span>' +
        (fc.counts ? '<span class="n">' + n + '</span>' : '') + '</button>';
    }
    function renderChips() {
      if (!all) return;
      var parts = [];
      var stock = (fc.showStock ? chip('avail', 'in', str.inStock, 'in') + chip('avail', 'lim', str.limited, 'lim') : '') +
        (fc.showSale && all.some(function (p) { return p.pct > 0; }) ? chip('sale', 'sale', str.sale, 'sale') : '');
      if (stock) parts.push(stock);
      if (fc.showType) {
        var t = TYPES.filter(function (g) { return all.some(function (p) { return p.group === g.label; }); })
          .map(function (g) { return chip('type', g.label, g.label); }).join('');
        if (t) parts.push(t);
      }
      if (fc.showSize) {
        var present = {};
        all.forEach(function (p) { p.sizes.forEach(function (s) { present[s] = true; }); });
        var keys = SIZE_ORDER.filter(function (k) { return present[k]; });
        var s = keys.map(function (k) { return chip('size', k, sizeLabel(k)); }).join('');
        if (s) parts.push(s);
      }
      if (fc.showPrice && BANDS.length) {
        var labels = fc.bandLabels || [];
        var pr = labels.map(function (l, i) { return all.some(function (p) { return p.band === String(i); }) ? chip('price', String(i), l) : ''; }).join('');
        if (pr) parts.push(pr);
      }
      chipsEl.innerHTML = '<div class="fb__chips">' + parts.join('<span class="fb__sep" aria-hidden="true"></span>') + '</div>';
      box.classList.add('is-ready');
    }
    function setCount() {
      if (!countEl) return;
      var total = all ? all.length : parseInt(countEl.getAttribute('data-total'), 10) || 0;
      var now = all && api.client ? visible.length : total;
      countEl.textContent = now + ' ' + (str.of || 'of') + ' ' + total + ' ' + (str.products || 'products');
    }

    /* ---------- Cards (same markup as snippets/mxdvs-card.liquid) ---------- */
    var WIDTHS = [400, 800, 1200, 1600, 2000, 2400];
    function srcset(url, w) {
      return WIDTHS.filter(function (x) { return !w || w >= x; }).map(function (x) {
        return (/[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + x) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + x) + ' ' + x + 'w';
      }).join(', ');
    }
    function card(p, index) {
      var sizes = index === 0 ? conf.sizes.big : conf.sizes.small;
      var media = '';
      if (p.im) media += '<img class="mx-card__img" src="' + esc(p.im) + '" srcset="' + esc(srcset(p.im, p.iw)) + '" sizes="' + esc(sizes) + '" alt="' + esc(p.ia) + '" width="' + p.iw + '" height="' + p.ih + '" loading="lazy">';
      if (p.am && conf.secondImage) media += '<img class="mx-card__img mx-card__img--alt" src="' + esc(p.am) + '" srcset="' + esc(srcset(p.am, p.aw)) + '" sizes="' + esc(sizes) + '" alt="' + esc(p.aa) + '" width="' + p.aw + '" height="' + p.ah + '" loading="lazy">';
      if (!p.av) media += '<span class="mx-tag mx-tag--out">' + esc(str.soldOut) + '</span>';
      else if (p.pct > 0) media += '<span class="mx-tag mx-tag--sale">' + esc(str.onSale) + ' <span data-decode-in="-' + p.pct + '%">-' + p.pct + '%</span></span>';
      var price = (p.pv ? 'From ' : '') + (p.pct > 0 && p.av && p.cm ? '<s>' + esc(p.cm) + '</s>' : '') + esc(p.pm);
      return '<li class="mx-col__item"><a href="' + esc(p.u) + '" class="mx-card' + (p.av ? '' : ' is-out') + '">' +
        '<span class="mx-card__media">' + media + '</span>' +
        '<span class="mx-card__meta"><span class="mx-list__no">' + (index + 1 < 10 ? '0' : '') + (index + 1) + '</span>' +
        '<span class="mx-card__name"><span class="mx-card__name-in" data-decode="' + esc(String(p.t).toUpperCase()) + '">' + esc(p.t) + '</span></span>' +
        '<span class="mx-list__type">' + esc(p.ty) + '</span>' +
        '<span class="mx-card__price">' + price + '</span></span></a></li>';
    }

    /* ---------- Grid in filter mode ---------- */
    var more = root.querySelector('[data-mxc-more]');
    function renderGrid() {
      visible = results();
      shown = 0;
      list.innerHTML = '';
      list.setAttribute('data-total', visible.length);
      if (!visible.length) {
        list.innerHTML = '<li class="mxc-none"><p class="mxc-desc">' + esc(str.none) + '</p></li>';
      }
      api.more();
      setCount();
    }
    api.more = function () {
      var next = visible.slice(shown, shown + conf.perPage);
      if (next.length) list.insertAdjacentHTML('beforeend', next.map(function (p, k) { return card(p, shown + k); }).join(''));
      shown += next.length;
      if (more) more.hidden = shown >= visible.length;
      if (window.MxCard && window.MxCard.scan) window.MxCard.scan(list);
    };
    function apply() {
      load().then(cards).then(function () {
        if (!all) return;
        api.client = true;
        root._mxcClient = api;
        renderChips();
        renderGrid();
      });
    }

    /* ---------- Terminal sort ---------- */
    var SORTS = conf.sorts || [];
    function sortName() { var s = SORTS.filter(function (x) { return x[0] === sort; })[0]; return s ? s[1] : ''; }
    function typeList() {
      var btns = sortEl.querySelectorAll('.sc__list button');
      btns.forEach(function (b) { b.textContent = ''; b.classList.toggle('is-active', b.getAttribute('data-sort') === sort); });
      var i = 0;
      (function next() {
        if (i >= btns.length) return;
        var b = btns[i++], t = b.getAttribute('data-type'), c = 0;
        if (reduce()) { b.textContent = t; next(); return; }
        (function ch() { b.textContent = t.slice(0, ++c); if (c < t.length) setTimeout(ch, 14); else setTimeout(next, 40); })();
      })();
    }
    function closeSort() { if (sortEl) sortEl.classList.remove('is-open'); }
    if (sortEl) {
      sortEl.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        if (b.hasAttribute('data-toggle')) {
          var open = !sortEl.classList.contains('is-open');
          sortEl.classList.toggle('is-open', open);
          b.setAttribute('aria-expanded', String(open));
          if (open) typeList();
          return;
        }
        if (b.dataset.sort) {
          closeSort();
          if (b.dataset.sort === sort) return;
          sort = b.dataset.sort;
          var nm = sortEl.querySelector('[data-name]');
          if (nm) decode(nm, sortName().toLowerCase(), 450);
          apply();
        }
      });
      sortEl.addEventListener('keydown', function (e) {
        if (!sortEl.classList.contains('is-open')) return;
        var btns = Array.prototype.slice.call(sortEl.querySelectorAll('.sc__list button'));
        var cur = btns.findIndex(function (b) { return b.classList.contains('is-active'); });
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          cur = (cur + (e.key === 'ArrowDown' ? 1 : -1) + btns.length) % btns.length;
          btns.forEach(function (b, i) { b.classList.toggle('is-active', i === cur); });
        } else if (e.key === 'Enter' && cur > -1) { e.preventDefault(); btns[cur].click(); }
        else if (e.key === 'Escape') closeSort();
      });
      document.addEventListener('click', function (e) { if (!sortEl.contains(e.target)) closeSort(); });
    }

    /* OSFA: on hover the chip decodes into "One size fits all", and back when the pointer leaves */
    function hoverChip(e, enter) {
      var btn = e.target.closest('.fb__chip');
      var s = btn && btn.querySelector('[data-hover]');
      if (!s || btn.contains(e.relatedTarget)) return;
      decode(s, enter ? s.getAttribute('data-hover').toUpperCase() : s.getAttribute('data-rest'), enter ? 350 : 250);
    }
    chipsEl.addEventListener('mouseover', function (e) { hoverChip(e, true); });
    chipsEl.addEventListener('mouseout', function (e) { hoverChip(e, false); });

    /* ---------- Chip clicks ---------- */
    chipsEl.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-g]');
      if (!b) return;
      var g = b.dataset.g, v = b.dataset.v, arr = sel[g], k = arr.indexOf(v);
      if (k > -1) arr.splice(k, 1);
      else if (fc.multi) arr.push(v);
      else sel[g] = [v];
      apply();
    });

    /* ---------- Sale: a broken tube light, one random letter flickers at a time ---------- */
    (function neon() {
      if (!fc.neon || reduce()) return;
      function flicker() {
        var letters = chipsEl.querySelectorAll('.f-neon i');
        if (letters.length) {
          var el = letters[Math.floor(Math.random() * letters.length)];
          var steps = [40 + Math.random() * 60, 30 + Math.random() * 50, 60 + Math.random() * 120, 40 + Math.random() * 60];
          if (Math.random() < 0.3) steps.push(200 + Math.random() * 400, 50);
          var off = true, t = 0;
          steps.forEach(function (d) {
            var o = off;
            setTimeout(function () { el.classList.toggle('is-off', o); }, t);
            t += d; off = !off;
          });
          setTimeout(function () { el.classList.remove('is-off'); }, t);
        }
        setTimeout(flicker, 300 + Math.random() * 2200);
      }
      setTimeout(flicker, 800);
    })();

    /* Start loading straight away (the facets list is light), so the chips show with the page */
    load();
    return api;
  }

  /* ============================================================
     PAGE
     ============================================================ */
  function typeText(el) {
    var text = el.getAttribute('data-mxc-type') || '';
    var out = el.querySelector('.mxc-desc__type');
    /* No typing layer, or reduced motion: the full text simply shows */
    if (!text || !out || reduce()) { el.classList.add('is-typed'); return; }
    var i = 0;
    function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    /* 09.10.2026: types quickly (about 8 to 22 ms a letter) over the invisible full text, which already gives the
       description its final height. The rest of the word being typed is already there (invisible), so a word never
       jumps to the next line halfway. When done, the typed layer empties and the full text shows in the same place. */
    (function step() {
      if (i > text.length) { out.textContent = ''; el.classList.add('is-typed'); return; }
      var end = text.indexOf(' ', i);
      if (end < 0) end = text.length;
      out.innerHTML = esc(text.slice(0, i)) + '<span class="mxc-desc__rest">' + esc(text.slice(i, end)) + '</span>';
      i++;
      setTimeout(step, 8 + Math.random() * 14);
    })();
  }

  function initPath(root) {
    root.querySelectorAll('.mxc-path a').forEach(function (a) {
      var text = a.textContent;
      a.addEventListener('mouseenter', function () { decode(a, text, 400); });
    });
  }

  function initMore(root, onAdd) {
    var btn = root.querySelector('[data-mxc-more]');
    var list = root.querySelector('.mx-col__list');
    if (!btn || !list) return;
    var busy = false, auto = false, io = null;
    var label = btn.textContent;

    function startAuto() {
      if (auto || !('IntersectionObserver' in window)) return;
      auto = true;
      io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !btn.hidden) load();
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(btn);
    }
    function load() {
      /* Filter mode: the next products come from the filtered list */
      if (root._mxcClient && root._mxcClient.client) {
        root._mxcClient.more();
        onAdd();
        startAuto();
        return;
      }
      var next = btn.getAttribute('data-next');
      if (busy || !next) return;
      busy = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = btn.getAttribute('data-loading') || 'Loading';
      var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(root.getAttribute('data-section-id'));
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('.mx-col__list > .mx-col__item');
          var frag = document.createDocumentFragment();
          items.forEach(function (li) { frag.appendChild(document.importNode(li, true)); });
          list.appendChild(frag);
          var nb = doc.querySelector('[data-mxc-more]');
          var nn = nb ? nb.getAttribute('data-next') : '';
          busy = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = label;
          if (nn) btn.setAttribute('data-next', nn);
          else { btn.removeAttribute('data-next'); btn.hidden = true; }
          if (window.MxCard && window.MxCard.scan) window.MxCard.scan(list);
          onAdd();
          /* After the first click: infinite scroll */
          if (nn) startAuto();
        })
        .catch(function () {
          busy = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = label;
        });
    }
    btn.addEventListener('click', load);
  }

  function init(root) {
    if (!root || root._mxc) return;
    root._mxc = true;
    var conf = {};
    try { conf = JSON.parse(root.querySelector('[data-mxc-config]').textContent); } catch (e) { conf = {}; }
    var desk = window.matchMedia('(min-width: 990px)');

    root.querySelectorAll('[data-mxc-type]').forEach(typeText);
    initPath(root);

    var counter = root.querySelector('[data-mxc-counter]');
    if (counter) {
      /* The section is a container query box, which would hold a fixed element in place: move it to <body> */
      document.querySelectorAll('body > [data-mxc-counter]').forEach(function (old) { old.remove(); });
      document.body.appendChild(counter);
    }
    var fx = mxFx(root, conf.fx || {}, function () { return !desk.matches; }, counter);
    var arrival = mxArrive(root, conf, fx.update);
    mxFilters(root, conf);
    initMore(root, function () { arrival.watch(); fx.update(); });
  }

  function boot() { document.querySelectorAll('[data-mxc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-mxc]');
    if (r) init(r);
  });

  window.MxCollectionPage = { init: init };
})();